import { FC } from "react";
import Image, { StaticImageData } from "next/image";
import S from "./index.module.scss";

interface IHeaderBackground {
  type: "black" | "image" | "video";
  src?: string | StaticImageData;
}

const HeaderBackground: FC<IHeaderBackground> = ({ type, src }) => {
  switch (type) {
    case "image":
      return src ? (
        <Image className={S.image} width={1600} height={287} src={src} alt="background" />
      ) : (
        <div className={S.black} />
      );
    case "video":
      return src ? (
        <video className={S.image} autoPlay muted loop>
          <source src={src as string} type="video/mp4" />
        </video>
      ) : (
        <div className={S.black} />
      );
    case "black":
    default:
      return <div className={S.black} />;
  }
};

export default HeaderBackground;
